export const academic=[
  {
    "displayText": "ANTIDISCRIMINATION CELL",
    "filename": "./assets/documentation/academic/ANTIDISCRIMINATION CELL.pdf",
    "link": ""
  },
  {
    "displayText": "ANTIRAGGING CELL",
    "filename": "./assets/documentation/academic/ANTIRAGGING CELL.pdf",
    "link": ""
  },
  {
    "displayText": "CAREER GUIDANCE & PLACEMENT CELL",
    "filename": "./assets/documentation/academic/CAREER GUIDANCE & PLACEMENT CELL.pdf",
    "link": ""
  },
  {
    "displayText": "GENDER SENSITIZATION CELL",
    "filename": "./assets/documentation/academic/GENDER SENSITIZATION CELL.pdf",
    "link": ""
  },
  {
    "displayText": "Governing body 2024-25",
    "filename": "./assets/documentation/academic/Governing body 2024-25.pdf",
    "link": ""
  },
  {
    "displayText": "Training and Placement Cell",
    "filename": "./assets/documentation/academic/Training and Placement Cell.pdf",
    "link": ""
  }
]